// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { get, toNumber, includes } from "lodash";
import { Icon } from "semantic-ui-react";

// Components
import Text from "@Components/Text";
import { getCallDurationLabel } from "@Utils/formats";

// Styles
import styles from "./styles.module.css";

const getCallLabel = (status, duration) => {
	const numDuration = toNumber(duration);
	if (status === "incoming") return { text: "Llamada Entrante", showDuration: false };
	if (status === "ongoing") return { text: "Llamada en Curso", showDuration: false };
	if (status === "rejected") return { text: "Llamada Rechazada", showDuration: false };
	if (status === "missed" || (status === "ended" && numDuration === 0)) return { text: "Llamada Perdida", showDuration: false };
	if (status === "ended") return { text: "Llamada Completada", showDuration: true };
	return { text: "Llamada Perdida", showDuration: false };
};

const getCallBackgroundColor = (status, duration) => {
	const numDuration = toNumber(duration);
	if (includes(["rejected", "missed"], status) || (status === "ended" && numDuration === 0)) return styles.error;
	if (includes(["ended"], status)) return styles.success;
	return styles.neutral;
};

const CallContent = ({ item }) => {
	const call = get(item, "call", {});
	const status = String(get(call, "status", "")).toLowerCase();
	const duration = get(call, "duration", 0);

	const { text, showDuration } = getCallLabel(status, duration);

	return (
		<div className={`${styles.call} ${getCallBackgroundColor(status, duration)}`}>
			<div className={styles.iconContainer}>
				<Icon name="phone" className={styles.phoneIcon} />
			</div>
			<div className={styles.callInfo}>
				<Text className={styles.text}>{text}</Text>
				{showDuration && <Text className={styles.duration}>{`Duración: ${getCallDurationLabel(toNumber(duration))}`}</Text>}
			</div>
		</div>
	);
};

CallContent.propTypes = {
	item: PropTypes.object,
};

export default CallContent;
